// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2jv2h","container":"styles_container__3Xv7B","header":"styles_header__2IPNq","title":"styles_title__393_a"};